module.exports = __webpack_public_path__ + "static/media/4.question.e2851b61.mp4";